import { useAppStore } from '@store'
import { Hole, Item } from '@types'
import { useMemo } from 'react'
import HoleDimentions from './HoleDimentions'
import ItemDimentions from './ItemDimentions'
import WallDimentions from './WallDimentions'

export default function GetOffsetDimentions(id: string) {
  const wall = useAppStore.use.items().get(id)

  const holes = wall.holes
  const lowItems = wall.lowItems
  const highItems = wall.highItems

  const prefs = useAppStore.use.prefs()
  const {
    VERCOTAVENTPRTAS,
    VERCOTAMUEBLESALTOS,
    VERCOTAMUEBLESBAJOS,
    DISTENTRECOTAS,
    DISTCOTAPARED,
  } = prefs
  const VERCOTACONSTRUCCION = prefs?.['VERCOTACONSTRUCCION']
  const VERCOTATABIQUES = prefs?.['VERCOTATABIQUES']
  const returnMemo = useMemo(() => {
    return [lowItems, highItems, holes, 'walls', 'partition'].reduce((acc, el, i) => {
      let offset = Number(acc.length * DISTENTRECOTAS + Number(DISTCOTAPARED))
      if (el === 'walls' && VERCOTACONSTRUCCION) {
        if (!acc.length) {
          offset = Number(acc.length * DISTENTRECOTAS + DISTCOTAPARED)
        }
        acc.push(
          <WallDimentions
            key={`Walls-${id}-${acc.length}-${wall.start.join('-')}-${wall.end.join('-')}-${
              wall.width
            }`}
            id={id}
            offset={offset}
          />,
        )
        return acc
      }
      if (el?.size && VERCOTAVENTPRTAS && i === 2) {
        acc.push(
          <HoleDimentions
            key={`hole-${id}-${acc.length}-${wall.start.join('-')}-${wall.end.join('-')}-${
              wall.width
            }`}
            id={id}
            elements={el as Hole[] | Item[]}
            offset={offset}
          />,
        )
        return acc
      }
      if (el?.size && i === 0 && VERCOTAMUEBLESBAJOS) {
        acc.push(
          <ItemDimentions
            key={`item-low-${id}-${offset}-`}
            id={id}
            elements={el}
            offset={offset}
          />,
        )
        return acc
      }
      if (el?.size && i === 1 && VERCOTAMUEBLESALTOS) {
        acc.push(
          <ItemDimentions
            key={`item-high-${id}-${offset}-`}
            id={id}
            elements={el}
            offset={offset}
          />,
        )
        return acc
      }
      return acc
    }, [])
  }, [
    holes,
    lowItems,
    highItems,
    DISTENTRECOTAS,
    DISTCOTAPARED,
    VERCOTACONSTRUCCION,
    VERCOTAVENTPRTAS,
    VERCOTAMUEBLESBAJOS,
    VERCOTAMUEBLESALTOS,
    id,
    wall.start,
    wall.end,
    wall.width,
  ])
  return returnMemo
}
